import React from "react";
import PropTypes from "prop-types";
import LatticeGrid from "lattice/lib/components/LatticeGrid";

function Breadcrumbs({ className, forwardRef, content, grid }) {
  let classList = ["shared__breadcrumbs"];
  classList = classList.concat(
    Array.isArray(className) ? className : className.split(" "),
  );

  const path = content.map((crumb) => {
    if (crumb.url) {
      return (
        <a
          key={crumb.id}
          href={crumb.url}
          aria-label={crumb.title}
          className={crumb.back ? "back" : ""}>
          <span>{crumb.title}</span>
        </a>
      );
    }
    return <span key={crumb.id}>{crumb.title}</span>;
  });
  const breadcrumbNav = (
    <nav className={classList.join(" ")} ref={forwardRef}>
      {path.reduce((prev, curr) => [
        prev,
        <span key={`${curr.key}-sep`} className="sep">
          /
        </span>,
        curr,
      ])}
    </nav>
  );
  if (grid) {
    return <LatticeGrid innerGrid>{breadcrumbNav}</LatticeGrid>;
  }
  return breadcrumbNav;
}

Breadcrumbs.designSystemProps = {
  className: {
    type: ["string", "array"],
    description: "List of classes for this element.",
    required: false,
    default: "",
    propType: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string),
    ]),
  },
  forwardRef: {
    type: ["function", "object"],
    description: "Ref to component or DOM element.",
    subProps: {
      current: {
        type: ["any"],
        description: "DOM node of Ref object",
        required: false,
        default: null,
      },
    },
    required: false,
    default: null,
    propType: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({ current: PropTypes.any }),
    ]),
  },
  content: {
    type: ["array"],
    description: "List of breadcrumb content",
    subProps: {
      id: {
        type: "string",
        description: "Unique id of breadcrumb",
        required: true,
      },
      title: {
        type: "string",
        description: "Breadcrumb title",
        required: true,
      },
      back: {
        type: "boolean",
        description: "If back arrow is included",
        required: false,
        default: null,
      },
      url: {
        type: "string",
        description: "URL of breadcrumb",
        required: false,
        default: null,
      },
    },
    required: true,
    propType: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        url: PropTypes.string,
        back: PropTypes.bool,
      }),
    ).isRequired,
  },
  grid: {
    type: "boolean",
    description: "Uses Lattice grid wrapper if true.",
    required: false,
    default: true,
  },
};

const propTypes = {};
const defaultProps = {};
Object.entries(Breadcrumbs.designSystemProps).map(([k, v]) => {
  if (v.propType) {
    propTypes[k] = v.propType;
  }
  if (v.default || typeof v.default !== "undefined") {
    defaultProps[k] = v.default;
  }
  return false;
});
Breadcrumbs.propTypes = { ...propTypes };
Breadcrumbs.defaultProps = { ...defaultProps };

Breadcrumbs.displayName = "Breadcrumbs";

export default Breadcrumbs;
